(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function ($) {
            function BestTourHelper(rootSelector) {
                this.$root = $(rootSelector);
                this.isCityChanged = false;
            }

            BestTourHelper.prototype.init = function () {
                if (!this.$root.length) {
                    return;
                }

                this.$root.addClass('best-tour-helper--ready');
                this.syncWhatsAppLinks();
                this.bindEvents();
            };

            BestTourHelper.prototype.bindEvents = function () {
                $(document).on('click', '.js_open-app-modal', this.handleAppModalClick.bind(this));
                $(document).on('click', '.js_best-tour-helper-callback', this.handleCallbackClick.bind(this));
                $('.best-tour-helper-modal-wrapper').on('click', '.callback-back-btn', this.handleCallbackBackClick.bind(this));
                $('#bestTourHelperModal').on('hide.bs.modal', this.resetBestTourHelperModal.bind(this));
                $(window).on('onLocation', this.handleLocationChange.bind(this));
            };

            BestTourHelper.prototype.getRoistatVisit = function () {
                if ('roistatGetCookie' in window && typeof window.roistatGetCookie === 'function') {
                    return window.roistatGetCookie('roistat_visit') || '';
                }

                return '';
            };

            BestTourHelper.prototype.handleLocationChange = function (event, cityName, cityId) {
                this.isCityChanged = true;
                this.syncWhatsAppLinks(cityId);
            };

            BestTourHelper.prototype.syncWhatsAppLinks = function (cityId) {
                var roistatVisit = this.getRoistatVisit();

                this.$root.each(function (_, root) {
                    var $root = $(root);
                    var phone = this.getWhatsAppPhone($root, cityId);

                    if (!phone) {
                        return;
                    }

                    $root.attr('data-whatsapp-phone', phone);
                    this.updateWhatsAppLink($root, phone, roistatVisit);
                }.bind(this));
            };

            BestTourHelper.prototype.syncWhatsAppQr = function (cityId) {
                var roistatVisit = this.getRoistatVisit();

                this.$root.each(function (_, root) {
                    var $root = $(root);
                    var phone = this.getWhatsAppPhone($root, cityId);

                    if (!phone) {
                        return;
                    }

                    this.updateWhatsAppQr($root, phone, roistatVisit);
                }.bind(this));
            };

            BestTourHelper.prototype.getWhatsAppPhone = function ($root, cityId) {
                var normalizedCityId = Number(cityId);

                if (normalizedCityId && window.cities && window.cities[normalizedCityId] && window.cities[normalizedCityId].whatsapp && window.cities[normalizedCityId].whatsapp.phone) {
                    return window.cities[normalizedCityId].whatsapp.phone.toString().replace(/\D/g, '');
                }

                return ($root.data('whatsapp-phone') || '').toString().replace(/\D/g, '');
            };

            BestTourHelper.prototype.updateWhatsAppLink = function ($root, phone, roistatVisit) {
                var linkEl = $root.find('.js_open-web-whatsapp').get(0);

                if (!linkEl || !linkEl.href) {
                    return;
                }

                var url = new URL('https://ht.kz/sendOnWhatsApp', window.location.origin);
                url.searchParams.set('phone', phone);

                if (roistatVisit) {
                    url.searchParams.set('roistatVisit', roistatVisit);
                }

                linkEl.href = url.toString();
            };

            BestTourHelper.prototype.updateWhatsAppQr = function ($root, phone, roistatVisit) {
                var $qr = $root.find('.js-qr-code');

                if (!$qr.length) {
                    return;
                }

                $qr.addClass('loading');

                $.post('/widget/callbackPopupQr', { roistatVisit: roistatVisit, phone: phone }).done(function (src) {
                    if (src) {
                        $qr.html('<img src="' + src + '" alt="qr">');
                    }
                }).always(function () {
                    $qr.removeClass('loading');
                });
            };

            BestTourHelper.prototype.handleAppModalClick = function (event) {
                var $button = $(event.currentTarget);
                var $modal = $button.closest('.best-tour-helper').find('.best-tour-helper-app-modal');

                this.track('open_app_qr_modal', {
                    Place: $button.data('place') || 'best-tour-helper'
                });

                if ($modal.length) {
                    $modal.modal('show');
                }
            };

            BestTourHelper.prototype.handleCallbackClick = function (event) {
                var $button = $(event.currentTarget);
                var $wrapper = $button.closest('.best-tour-helper-modal-wrapper');
                var $modal = $('#bestTourHelperModal');
                var $globalTrigger = $('#cbpwr-clickable');

                this.track('callback_listing', {
                    Place: $button.data('place') || 'best-tour-helper'
                });

                if ($wrapper.length) {
                    this.updateModalWhatsAppQr($wrapper);

                    if (typeof window.showCallbackForm === 'function') {
                        window.showCallbackForm('other', $wrapper.find('.best-tour-helper-modal-form'));
                    }

                    $wrapper.find('.best-tour-helper-modal-content').addClass('hidden');
                    $wrapper.find('.best-tour-helper-modal-form').removeClass('hidden');
                    return;
                }

                if ($modal.length && !$wrapper.length) {
                    $modal.modal('show');
                    return;
                }

                if ($globalTrigger.length) {
                    $globalTrigger.trigger('click');
                }
            };

            BestTourHelper.prototype.updateModalWhatsAppQr = function ($wrapper) {
                if (!this.isCityChanged) {
                    return;
                }

                var cityId = window.app && window.app.city ? window.app.city.id : null;
                var $root = $wrapper.find('.best-tour-helper');
                var phone = this.getWhatsAppPhone($root, cityId);

                if (!phone) {
                    return;
                }

                this.updateWhatsAppQr($root, phone, this.getRoistatVisit());
                this.isCityChanged = false;
            };

            BestTourHelper.prototype.handleCallbackBackClick = function (event) {
                var $button = $(event.currentTarget);
                var $wrapper = $button.closest('.best-tour-helper-modal-wrapper');

                if (!$wrapper.length) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                $wrapper.find('.best-tour-helper-modal-form').addClass('hidden');
                $wrapper.find('.best-tour-helper-modal-content').removeClass('hidden');
            };

            BestTourHelper.prototype.resetBestTourHelperModal = function () {
                var $wrapper = $('#bestTourHelperModal .best-tour-helper-modal-wrapper');

                if (!$wrapper.length) {
                    return;
                }

                $wrapper.find('.best-tour-helper-modal-form').addClass('hidden');
                $wrapper.find('.best-tour-helper-modal-content').removeClass('hidden');
            };

            BestTourHelper.prototype.track = function (name, properties) {
                if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                    window.brxTracking.sendAnalyticsEvent(name, properties || {});
                }
            };

            $(function () {
                new BestTourHelper('.best-tour-helper').init();
            });
        })(jQuery);
    }, {}] }, {}, [1]);